"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectCatalogMeta = void 0;
const reselect_1 = require("reselect");
// eslint-disable-next-line import/prefer-default-export
exports.selectCatalogMeta = (0, reselect_1.createSelector)((state) => state.catalogMeta, (catalogMeta) => catalogMeta);
